import React from 'react';
import {
  Box,
  VStack,
  Text,
  Icon,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Button,
} from '@chakra-ui/react';
import { FiLock, FiShield } from 'react-icons/fi';
import { useUserContext } from '../context/UserContext';

const BranchAccessRestriction = ({ 
  featureName = "This feature",
  showUpgradeButton = false,
  onUpgradeClick = null 
}) => {
  const { isAdmin } = useUserContext();

  // If user is admin, don't show restriction
  if (isAdmin) {
    return null;
  }

  return (
    <Box
      textAlign="center"
      py={12}
      px={6}
      bg="gray.50"
      borderRadius="lg"
      border="1px solid"
      borderColor="gray.200"
    >
      <VStack spacing={6}>
        {/* Icon */}
        <Box
          p={4}
          bg="red.100"
          borderRadius="full"
          color="red.600"
        >
          <Icon as={FiShield} boxSize={8} />
        </Box>

        {/* Title */}
        <VStack spacing={2}>
          <Text fontSize="xl" fontWeight="700" color="gray.800">
            Access Restricted
          </Text>
          <Text fontSize="md" color="gray.600" maxW="400px">
            {featureName} is only available to administrators. 
            Branch users cannot access this feature.
          </Text>
        </VStack>

        {/* Alert */}
        <Alert status="warning" borderRadius="md" maxW="500px">
          <AlertIcon />
          <Box>
            <AlertTitle>Administrator Access Required</AlertTitle>
            <AlertDescription>
              This feature requires administrator privileges. Please contact your system administrator if you need access to this functionality.
            </AlertDescription>
          </Box>
        </Alert>

        {/* Optional Upgrade Button */}
        {showUpgradeButton && onUpgradeClick && (
          <Button
            colorScheme="blue"
            onClick={onUpgradeClick}
            leftIcon={<FiLock />}
          >
            Contact Administrator
          </Button>
        )}
      </VStack>
    </Box>
  );
};

export default BranchAccessRestriction; 